import { styled } from "styled-components";

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	border-radius: 5px;
	width: 100%;
	margin: auto;
	gap: 10px;
	padding: 30px;

	& > p {
		margin: 0;
		padding: 0;
	}
`;

export const FieldWrapper = styled.p`
	display: flex;
	flex-direction: column;
	gap: 10px;

	& > label {
		font-family: Roboto, sans-serif;
		font-size: 12px;
		font-weight: bold;
	}

	& input {
		border-radius: 5px;
		border: 1px solid #000;
		height: 38px;
		padding-left: 10px;
		padding-right: 10px;
		width: -webkit-fill-available;
	}
`;

export const LinkStyling = styled.a`
	font-family: Roboto, sans-serif;
	font-size: 14px;
	color: #464f27;
	text-decoration: none;
	margin: auto auto 20px;
	display: flex;
	justify-content: center;

	&:hover {
		text-decoration: underline;
	}
`;

export const BtnAction = styled.button`
	max-width: 144px;
	width: 100%;
	height: 38px;
	font-size: 16px;
	font-weight: 500;
	background-color: #3a7dc9;
	color: #fff;
	border: none;
	cursor: pointer;
	margin: 40px auto;
	display: flex;
	text-align: center;
	align-items: center;
	place-content: center;
	flex-wrap: wrap;
	border-top-left-radius: 5px;
	border-bottom-right-radius: 5px;
	border-bottom-left-radius: 0;
	border-top-right-radius: 0;
	transition: 0.2s ease;

	&:hover {
		background-color: #1a3f7a;
	}

	&:disabled {
		background-color: #8aa9cf;
		cursor: not-allowed;
		opacity: 0.7;
	}
`;

export const PasswordWrapper = styled.div`
	position: relative;
`;

export const PasswordVisibility = styled.button`
	padding: 0;
	background-color: transparent !important;
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	cursor: pointer;
	font-size: 14px;
	color: #1a3f7a;
	outline: none;

	&:focus {
		border: none;
		background-color: transparent !important;
		color: #1a3f7a !important;
	}

	&:hover {
		background-color: transparent !important;
		color: #1a3f7a !important;
	}

	&:active {
		border: none;
		color: #1a3f7a !important;
	}
`;

export const ErrorBox = styled.div`
	height: 40px;

	& > div {
		background-color: #ffe6e6;
		color: #7e1417;
		border: 1px solid #7e1417;
		border-radius: 5px;
		padding: 10px;
		font-size: 12px;
		font-family: Roboto, sans-serif;
	}
`;

export const NoticeBar = styled.div`
	background-color: #fff;
	color: #d32f2f;
	border: 1px solid #d32f2f;
	border-radius: 5px;
	padding: 10px 12px;
	margin-bottom: 15px;
	font-size: 14px;
	font-family: Roboto, sans-serif;
`;

export const NameWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	width: 100%;

	& > div {
		width: calc(50% - 5px);

		& input {
			border-radius: 5px;
			border: 1px solid #000;
			height: 38px;
			width: -webkit-fill-available;
		}
	}
`;
